 import request from '@/utils/ajax'


export function saveFeishuConfig(data) {
    return request({
        url: '/wx/manage/larkBotConfig/save',
        method: 'post',
        data: data
    })
}

export function editFeishuConfig(data) {
    return request({
        url: '/wx/manage/larkBotConfig/update',
        method: 'put',
        data: data
    })
}

export function deleteFeishuConfig(data) {
    return request({
        url: '/wx/manage/larkBotConfig/delete',
        method: 'post',
        data: data
    })
}
